import { Expose, Type } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { LprCameraType, LprIntegrationType } from '../constants/lpr-camera.constants';

export class FsLprCamera extends SnModel {
  @Expose()
  @Type(() => Date)
  public lastObservedDate: Date;

  @Expose()
  public readsOnLastObserved: number;

  @Expose()
  public name: string;

  @Expose()
  public up: boolean;

  @ExposeRawData()
  public position: any;

  @Expose()
  public type: LprCameraType;

  @Expose({ name: 'name' })
  public id: string;

  @Expose()
  public link?: string;

  @Expose()
  public integrationType: LprIntegrationType;

  @Expose()
  public integrationId: string;

  @Expose()
  public properties: {
    id: string;
    name: string;
  };

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
